import { render, staticRenderFns } from "./SendCurrencyContainer.vue?vue&type=template&id=206646d2&scoped=true&"
import script from "./SendCurrencyContainer.vue?vue&type=script&lang=js&"
export * from "./SendCurrencyContainer.vue?vue&type=script&lang=js&"
import style0 from "./SendCurrencyContainer.vue?vue&type=style&index=0&id=206646d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206646d2",
  null
  
)

export default component.exports